import frontEndVars from '~/front-end-vars';
import $ from '~/qwery';
import bean from '~/bean';
import popupManager from '~/components/popup/manager';

export default class Wrapper {
    constructor(popup, options = {}) {
        this.$popup = $(popup);
        this._options = options;
        if (this.options('mode') == 'hideViewportScrollbars') {
            this.$el = $(document.createElement('div'));
            this.$el.attr('class', 'popup-wrapper');
            if (this.options('scrollbars')['vert'])
                this.$el.css('overflow-y', 'scroll');
            if (this.options('scrollbars')['horz'])
                this.$el.css('overflow-x', 'scroll');

            const $popupWrapper2 = $(document.createElement('table'));
            $popupWrapper2.attr('class', 'popup-wrapper-2');

            const row = $popupWrapper2[0].insertRow();

            this.$popupWrapper3 = $(row.insertCell());
            this.$popupWrapper3.attr('class', 'popup-wrapper-3');

            this.$el.append($popupWrapper2);
            this.$popupWrapper3.append(this.$popup);
            document.body.appendChild(this.$el[0]);

            bean.on(this.$el[0], 'click', () => {
                if ( ! this.popupClicked())
                    this.options('onClick')();
                this.popupClicked(false);
            });
        } else {
            document.body.appendChild(this.$popup[0]);
        }
    }

    popupClicked(popupClicked) {
        if (popupClicked != null)
            this._popupClicked = popupClicked;
        return this._popupClicked;
    }

    updateExtents() {
        let paddingTop = (this.$el[0].clientHeight - this.$popup[0].offsetHeight) / 3
            - parseFloat(frontEndVars['popup-min-margin']);
        if (paddingTop < 0)
            paddingTop = 0;
        this.$el.css('padding-top', paddingTop + 'px');
    }

    destroy() {
        if (this.options('mode') == 'hideViewportScrollbars')
            this.$el.remove();
        else
            this.$popup.remove();
    }

    options(options) {
        if (options != null && typeof options != 'string')
            Object.assign(this._options, options);
        return options && typeof options == 'string'
            ? this._options[options]
            : this._options;
    }

    maxContentWidth() {
        return this.options('mode') == 'hideViewportScrollbars'
            ? popupManager.noPopupViewportClientWidth()
                - parseFloat(this.$popupWrapper3.css('padding-left'))
                - parseFloat(this.$popupWrapper3.css('padding-right'))
            : document.documentElement.clientWidth;
    }

    maxContentHeight() {
        return this.options('mode') == 'hideViewportScrollbars'
            ? popupManager.noPopupViewportClientHeight()
                - parseFloat(this.$popupWrapper3.css('padding-top'))
                - parseFloat(this.$popupWrapper3.css('padding-bottom'))
            : document.documentElement.clientHeight;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/wrapper.js